<template>
  <div class="app flex-row align-items-center login-background">
    <div v-if="submitting || authPending" class="login-overlay">
      <div class="login-overlay-card">
        <b-spinner small class="mr-2"></b-spinner>
        <div class="login-overlay-text">
          <div class="login-overlay-title">Signing in…</div>
          <div class="login-overlay-subtitle">Please wait</div>
        </div>
      </div>
    </div>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4 login-card">
              <b-card-body>
                <img src="/img/logo-symbol.png">
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>
                <p v-if="notice" class="text-info">{{ notice }}</p>
                <p v-if="errors.length">
                  <b>Please correct the following error(s):</b>
                <ul>
                  <li v-for="error in errors">{{ error }}</li>
                </ul>
                </p>
                <form @submit.prevent="login">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <input type="text" v-model="user" class="form-control" placeholder="Username" :disabled="submitting || authPending">
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <input type="password" v-model="pass" class="form-control" placeholder="Password" :disabled="submitting || authPending">
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" type="submit" class="px-4" :disabled="submitting || authPending">
                        <b-spinner v-if="submitting || authPending" small class="mr-2"></b-spinner>
                        <span>{{ submitting || authPending ? 'Logging in...' : 'Login' }}</span>
                      </b-button>
                    </b-col>
                  </b-row>
                </form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import Auth from '../../Auth'
  import {mapActions, mapGetters} from 'vuex'
  export default {
    name: 'Login',
    data () {
      return {
        user: null,
        pass: null,
        errors: [],
        notice: '',
        submitting: false
      }
    },
    computed: {
      ...mapGetters(['authPending'])
    },
    created () {
      if (this.$route.query.reason === 'expired') {
        this.notice = 'Your session expired. Please sign in again.'
      }
    },
    methods: {
      ...mapActions(['resetPermission', 'setAuthPending']),
      waitForAuth () {
        return new Promise((resolve, reject) => {
          if (this.$store.getters.authUser) {
            resolve()
            return
          }
          const timeout = setTimeout(() => {
            unwatch()
            reject(new Error('Auth timeout'))
          }, 5000)
          const unwatch = this.$store.watch(
            state => state.socket.user,
            val => {
              if (val) {
                clearTimeout(timeout)
                unwatch()
                resolve()
              }
            }
          )
        })
      },
      login () {
        this.errors = []
        this.notice = ''
        this.submitting = true
        let invalid = false
        if (!this.user) {
          this.errors.push('Username is required.')
          invalid = true
        }
        if (!this.pass) {
          this.errors.push('Password is required.')
          invalid = true
        }
        if (invalid) {
          this.submitting = false
          return
        }
        Auth.login(this.user, this.pass, (result) => {
          if (!result || !result.ok) {
            this.errors.push(result && result.message ? result.message : 'Username or Password is incorrect.')
            this.submitting = false
            return
          }
          this.resetPermission()
          this.setAuthPending(true)
          if (this.$socket) {
            this.$disconnect()
          }
          this.$connect()
          this.waitForAuth().then(() => {
            this.$router.replace(this.$route.query.redirect || '/').catch(() => {})
            this.submitting = false
          }).catch(() => {
            this.setAuthPending(false)
            this.errors.push('Login succeeded, but session did not initialize. Please try again.')
            this.submitting = false
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-overlay {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(8, 12, 16, 0.6);
    z-index: 9999;
  }

  .login-overlay-card {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    background: rgba(10, 14, 20, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
    color: #f1f3f5;
  }

  .login-overlay-text {
    display: flex;
    flex-direction: column;
  }

  .login-overlay-title {
    font-weight: 700;
    letter-spacing: 0.2px;
  }

  .login-overlay-subtitle {
    color: rgba(255, 255, 255, 0.65);
    font-size: 12px;
  }
</style>
